import template from './booking-create.html';
import controller from './booking-create.controller';
import './booking-create.styl';

const bookingCreateComponent = {
  template,
  controller,
  controllerAs: 'bookingCreate',
  require: {
    app: '^^app'
  }
};

export default bookingCreateComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-create/booking-create.component.js
 **/